import { toast } from 'sonner';
import { ApiError } from '@/lib/api';

/** Same call shape the pages already use: `notify(text)` or `notify(text, 'error')`. */
export const notify = (text: string, tone: 'ok' | 'error' = 'ok') => (tone === 'ok' ? toast.success(text) : toast.error(text));
export const useToast = () => notify;

/**
 * Every dashboard error surfaces as a toast, not inline. The message doubles as the toast id, so a
 * request that keeps failing (polling while the API is down) updates one toast instead of stacking.
 */
export function notifyError(error: unknown) {
  // A 401 that survives the refresh already sends the user to the sign-in page.
  if (error instanceof ApiError && error.status === 401) return;
  const message = error instanceof Error ? error.message : String(error);
  const details = error instanceof ApiError && error.details?.length
    ? error.details.map((d) => (d.path ? `${d.path}: ${d.message}` : d.message)).join('\n')
    : undefined;
  toast.error(message, { id: message, description: details });
}
